export default __webpack_public_path__ + "static/media/banner-about.d0a747b1.webp";